<template>
  <span
    v-if="!editing"
    :class="{ 'text-success': value, 'text-danger': !value }"
  >
    {{ humanReadableValue }}
  </span>
  <span v-else>
    <input
      v-bind="$attrs"
      type="text"
      v-autowidth="{ maxWidth: '500px', minWidth: '100px', comfortZone: 0 }"
      class="form-control inline small py-0"
      :value="value[component][index]"
      @input="$emit('input', $event.target.value, component, index)"
    />

    <button
      v-if="helper && helper !== '' && helper !== 'null'"

      @click="show"
      v-on-clickaway="close"

      :id="id"
      class="btn btn-link p-0"

      data-container="body"
      data-toggle="popover"
      data-placement="top"
      :data-content="decodeURI(helper)"
    >
      <i class="fas fa-question-circle"></i>
    </button>
  </span>
</template>

<script>
import Vue from 'vue';
import VueInputAutowidth from 'vue-input-autowidth';
import contractInlineContentMixin from '@/Mixins/contractInlineContentMixin';

Vue.use(VueInputAutowidth);

export default {
  mixins: [contractInlineContentMixin],

  inheritAttrs: false,

  computed: {
    humanReadableValue() {
      return this.value;
    },
  },
};
</script>
